import axiosInstance from "../app/axios";
import { ColumnFilterValuesResponse } from "../components/common/ColumnFilterDropdown/useColumnFilters";

interface ColumnFilterValuesParams {
  search?: string;
  take?: number;
  otherFilters?: Record<string, string[]>;
  searchText?: string;
}

/**
 * Builds a "get distinct column filter values" API call for any entity exposing
 * a `POST {basePath}search/filters/:column` endpoint (the backend counterpart in
 * mowi_migration is `parseColumnFilterRequest` + `getDistinctColumnValues`).
 * Reused by every table adopting <ColumnFilterDropdown/> + useColumnFilters.
 */
export const createColumnFilterValuesFetcher =
  (basePath: string) =>
  async (
    column: string,
    { search, take, otherFilters, searchText }: ColumnFilterValuesParams,
  ): Promise<ColumnFilterValuesResponse> => {
    const result = await axiosInstance.post(
      `${basePath}search/filters/${column}?take=${take ?? 50}`,
      {
        search: search ?? "",
        searchText: searchText ?? "",
        columnFilters: otherFilters ?? {},
      },
    );

    return result.data;
  };
